import { useState } from "react";
import { Button, Checkbox, Modal } from "antd";

interface AskVivoDeleteConfirmModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  saveDontAskAgain: (value: boolean) => void;
  count?: number;
}

export default function AskVivoDeleteConfirmModal({
  open,
  onCancel,
  onConfirm,
  saveDontAskAgain,
  count = 1,
}: AskVivoDeleteConfirmModalProps) {
  const [dontAskAgain, setDontAskAgain] = useState(false);

  const handleConfirm = () => {
    saveDontAskAgain(dontAskAgain);
    onConfirm();
    onCancel();
  };

  return (
    <Modal
      centered
      open={open}
      onCancel={onCancel}
      zIndex={1070}
      afterClose={() => setDontAskAgain(false)}
      footer={
        <div className="flex items-center justify-between">
          <Button type="default" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            type="primary"
            className="delete-selected border-0"
            onClick={handleConfirm}
          >
            Delete
          </Button>
        </div>
      }
    >
      <p className="font-bold mb-3">
        {count > 1 ? "Delete saved items?" : "Delete saved item?"}
      </p>
      <p>
        {count > 1
          ? `Are you sure you want to delete these ${count} history items?`
          : "Are you sure you want to delete this history item?"}
      </p>
      <p>You won&apos;t be able to recover {count > 1 ? "them" : "it"}.</p>
      <Checkbox
        checked={dontAskAgain}
        onChange={(e) => setDontAskAgain(e.target.checked)}
        className="mt-4 mb-3"
      >
        <span className="text-[#575D62] text-sm">Don&apos;t ask me again</span>
      </Checkbox>
    </Modal>
  );
}
